(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-with-content"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.fifty-fifty .read-more-button, .left-fifty-fifty .read-more-button');

    buttons.forEach(button => {
      button.addEventListener('click', function(event) {
        event.preventDefault();

        const container = this.closest('.expandable-text-container');
        
        if (container) {
          if (container.classList.contains('expanded')) {
            this.textContent = 'Read More';
            this.setAttribute('aria-expanded', 'false');
            container.classList.remove('expanded');
          } else {
            this.textContent = 'Read Less';
            this.setAttribute('aria-expanded', 'true');
            container.classList.add('expanded');
          }
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
